if (!customElements.get('vxa-accessory-picker')) {
  customElements.define('vxa-accessory-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.variants = JSON.parse(this.querySelector('[data-vxa-variants]').textContent);
      this.groups = Array.from(this.querySelectorAll('[data-vxa-option-group]'));
      this.input = this.querySelector('[data-vxa-variant-id]');
      this.quantity = this.querySelector('[name="quantity"]');
      this.submit = this.querySelector('[name="add"]');
      this.input.disabled = false;
      this.select(this.variants.find(variant => String(variant.id) === this.input.value) || this.variants[0], false);
      this.onChange = event => {
        const group = event.target.closest('[data-vxa-option-group]');
        if (!group || event.target.type !== 'radio') return;
        const index = Number(group.dataset.optionIndex);
        const values = this.selected.options.slice();
        values[index] = event.target.value;
        const candidates = this.variants.filter(variant => values.slice(0, index + 1).every((value, position) => variant.options[position] === value));
        const exact = candidates.find(variant => values.every((value, position) => variant.options[position] === value));
        const score = variant => values.reduce((sum, value, position) => sum + (variant.options[position] === value ? 2 : 0), variant.available ? 1 : 0);
        const variant = exact || candidates.sort((a, b) => score(b) - score(a))[0];
        if (variant) this.select(variant, true);
      };
      this.addEventListener('change', this.onChange);
      this.onPopState = () => {
        const id = new URL(window.location.href).searchParams.get('variant');
        const variant = this.variants.find(item => String(item.id) === id);
        if (variant) this.select(variant, false);
      };
      window.addEventListener('popstate', this.onPopState);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      window.removeEventListener('popstate', this.onPopState);
      this.bound = false;
    }

    select(variant, updateUrl) {
      this.selected = variant;
      this.input.value = variant.id;
      this.groups.forEach((group, index) => {
        group.querySelector('[data-vxa-option-current]').textContent = variant.options[index];
        group.querySelectorAll('input[type="radio"]').forEach(radio => {
          const candidates = this.variants.filter(item => item.options[index] === radio.value && variant.options.slice(0, index).every((value, position) => item.options[position] === value));
          radio.checked = radio.value === variant.options[index];
          radio.disabled = candidates.length === 0;
          radio.closest('label').classList.toggle('is-sold-out', candidates.length > 0 && !candidates.some(item => item.available));
        });
      });
      this.querySelector('[data-vxa-selection]').textContent = variant.title;
      const sku = this.querySelector('[data-vxa-sku]');
      sku.hidden = !variant.sku;
      sku.querySelector('span').textContent = variant.sku || '';
      this.querySelector('[data-vxa-price]').textContent = variant.price;
      const compare = this.querySelector('[data-vxa-compare]');
      compare.hidden = !variant.compare;
      compare.textContent = variant.compare || '';
      this.quantity.min = variant.minimum || 1;
      this.quantity.step = variant.increment || 1;
      if (variant.maximum !== null) this.quantity.max = variant.maximum;
      else this.quantity.removeAttribute('max');
      const min = Number(this.quantity.min);
      const step = Number(this.quantity.step);
      const value = Math.max(min, min + Math.ceil(((Number(this.quantity.value) || min) - min) / step) * step);
      this.quantity.value = variant.maximum === null ? value : Math.min(value, variant.maximum);
      this.submit.disabled = !variant.available;
      this.submit.querySelector('span').textContent = variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
      this.querySelector('.product-form__error-message-wrapper').hidden = true;
      const thumbnail = variant.media && this.closest('vxa-product').querySelector(`[data-vxa-target="${variant.media}"]`);
      if (thumbnail) thumbnail.click();
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }
  });
}
